import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { NavigationTabData } from 'src/app/models/navigation-tab-data.model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { TimeService } from 'src/app/services/time-service/time.service';
import { WebservicesService } from "src/app/services/webservices/webservices.service";
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-win-loss',
  templateUrl: './win-loss.component.html',
  styleUrls: ['./win-loss.component.scss'],
})
export class WinLossComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild(IonContent) table: IonContent;
  @Input() navigateBackPage: string;
  @Input() callBackFn;

  public error = null;
  public winLossRecordType;
  public dailyTransactions: any[] = [];
  public aggregateTransactions: any[] = [];
  public testRecords: any[] = [];
  public totalRecords: number = 0;
  public currentPage: number = 1;
  public maxPage: number = 1;
  public dailyPageData: number;
  public showDailyTable = false;
  public showSportsTable = false;
  public showAggregateTable = false;
  public showAggregateNoResults = false;
  public showDailyNoResults = false;
  public downloadDisabled = false;
  public searchDailyDisabled = false;
  public searchAggregateDisabled = false;
  public expandedTotalData = true;
  public expandedCasinoData = true;
  public expandedSportsData = true;
  
  public ontarioFlag: boolean = false;
  public hasCasino: boolean = false;
  public hasSports: boolean = false;


  startDate: any;
  // todayDate: Date;
  fromDate: string;
  toDate: string;
  dateRange: number;

  startDateAggregate: Date;
  fromDateAggregate: string;
  toDateAggregate: string;
  aggregateDaysRange: number;
  fromDateAggregateMin: string

  public tabData: NavigationTabData[] = [
    {
      text: "Transaction history",
      active: false,
      disabled: false,
      link: "TransactionHistoryComponent",
    },
    {
      text: "Win / Loss",
      active: true,
      disabled: false,
      link: "WinLossComponent",
    },
    {
      text: "Limit history",
      active: false,
      disabled: false,
      link: "LimitsHistoryComponent",
    },
    {
      text: "Transfers",
      active: false,
      disabled: false,
      link: "GameTransactionsComponent",
    }
  ];
  constructor(
    public timeService: TimeService,
    private cashierService: CashierService,
    public successMessageService: SuccessMessageService,
    private appLinks: AppLinksService,
    protected config: ConfigService,
    private navigator: Navigator,
    private webService: WebservicesService,
    public platform: Platform,
    private configService : ConfigService
  ) {
    this.winLossRecordType = 'daily';
    let country = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    if(country === "USA") {
     this.tabData = this.tabData.concat([{
        text: "Tax report",
        active: false,
        disabled: false,
        link: "TaxReportsComponent",
      }]);
    }
  }

  ngOnInit() {
    this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
  }

  dailyCalendarUpdate(event) {
    this.toDate = event.toDate;
    this.fromDate = event.fromDate;
    this.searchDailyDisabled = event.search;
    this.successMessageService.clearMessage();
  }

  aggregateCalendarUpdate(event) {
    this.toDateAggregate = event.toDate;
    this.fromDateAggregate = event.fromDate;
    this.searchAggregateDisabled = event.search;
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();

    //Added Aggregate days to pick from config.
    this.aggregateDaysRange = this.config.getConfig().FEATURE_AGGREGATE_WIN_LOSS_DAYS_RANGE || 182
    let today = new Date();
    let date = new Date();
    let previousDate = new Date(date.setDate(today.getDate()));
    this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
    this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(previousDate)); //setting today date fallback and initial value for 'To' data passed to webservices
    this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
    //Adjusting 182 days from date variable
    let aggregateDate = new Date();
    this.startDateAggregate = new Date(aggregateDate.setDate(aggregateDate.getDate()  - this.aggregateDaysRange)); //set start date 6 months (182) to dynamically for Aggregate Date selection
    this.toDateAggregate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(previousDate));
    this.fromDateAggregate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(aggregateDate)) //'From' data
    this.fromDateAggregateMin = this.startDateAggregate.toISOString().split('T')[0];

    // Disable 18 months before date selection from Today's date so, user can't select past 18 months

    this.checkEnabledProductVerticals();
  }

  onDailySearch() {
    this.searchDailyDisabled = true;
    this.showDailyTable = false;
    this.currentPage = 1;
    this.onGetDailyWinLossTransactions()
  }

  onAggregateSearch() {
    this.searchAggregateDisabled = true;
    this.showAggregateTable = false;
    this.currentPage = 1;
    this.onGetAggregateWinLossTransactions()
  }

  onGetDailyWinLossTransactions() {
    var requestObj: any = {};
    requestObj.pageno = this.currentPage;
    requestObj.date_from = this.fromDate;
    requestObj.date_to = this.toDate;

    this.showDailyTable = false;
    this.showDailyNoResults = false;

    this.cashierService.callGetDailyWinLossBalance(requestObj).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          const pageNumber = Number(response.payload.page_no);
          this.totalRecords = response.result;
          this.dailyPageData = response.payload.page_size;
          this.dailyTransactions = this.arrayReverseObj(response.payload.win_loss_balance_summary_page);

          this.currentPage = pageNumber;
          this.maxPage = response.payload.total_pages;

          if (this.totalRecords > 0 && this.dailyPageData > 0) {
            this.showDailyTable = true;
            this.showDailyNoResults = false;
          }
          else {
            this.showDailyTable = false;
            this.showDailyNoResults = true;
          }

          this.downloadDisabled = false;
          this.table.scrollToTop();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  arrayReverseObj(obj) {
    let newArray = []

    Object.keys(obj)
      .sort()
      .reverse()
      .forEach(key => {
        newArray.push({
          'key': key,
          'value': obj[key]
        })
      })

    return newArray
  }

  onGetAggregateWinLossTransactions() {
    var requestObj: any = {};
    requestObj.pageno = this.currentPage;
    requestObj.date_from = this.fromDateAggregate;
    requestObj.date_to = this.toDateAggregate;

    this.showAggregateTable = false;
    this.showAggregateNoResults = false;

    this.cashierService.callGetAggregateWinLossBalance(requestObj).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          const pageNumber = Number(response.payload.page_no);
          this.totalRecords = response.result;
          this.aggregateTransactions = response.payload;
          this.currentPage = pageNumber;
          this.maxPage = response.payload.total_pages;

          if (this.totalRecords > 0) {
            this.showAggregateTable = true;
            this.showAggregateNoResults = false;
          }
          else {
            this.showAggregateTable = false;
            this.showAggregateNoResults = true;
          }

          this.downloadDisabled = false;
          this.table.scrollToTop();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  onDownloadAggregate() {
    var requestObj: any = {};
    requestObj.pageno = this.currentPage;
    requestObj.date_from = this.fromDateAggregate;
    requestObj.date_to = this.toDateAggregate;
    const url = this.cashierService.downloadAggregateWinLossBalance(requestObj);
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      console.log('onDownloadAggregate url:'+url);
      this.webService.download(url,'winloss_aggregate_'+requestObj.date_from+'_'+requestObj.date_to+'.csv');
    } else {
      this.appLinks.openDownloadablePage(url);
    }
    return false;
  }

  onDownloadDaily() {
    var requestObj: any = {};
    requestObj.pageno = this.currentPage;
    requestObj.date_from = this.fromDate;
    requestObj.date_to = this.toDate;

    let url = this.cashierService.downloadGetDailyWinLossBalance(requestObj);
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      console.log('onDownloadDaily url:'+url);
      this.webService.download(url,'winloss_daily_'+requestObj.date_from+'_'+requestObj.date_to+'.csv');
    } else {
      this.appLinks.openDownloadablePage(url);
    }
    return false;
  }

  tableHeaderClicked(table) {
    console.log("test ", table);
    if (table == 'total') {
      this.expandedTotalData = !this.expandedTotalData;
    }
    if (table == 'casino') {
      this.expandedCasinoData = !this.expandedCasinoData;
    }
    if (table == 'sports') {
      this.expandedSportsData = !this.expandedSportsData;
    }
  }

  onChangeRecord(event) {
    this.winLossRecordType = event;
  }

  checkEnabledProductVerticals() {
    this.hasCasino = true;
  }
  closeModal = () => {
    console.log(this.callBackFn);
    if (!!this.callBackFn) {
      this.navigator.dismiss();
      this.callBackFn();
    } else {
      this.navigator.toLobby();
    }
  }


  onBack = () => {
    if (!!this.navigateBackPage) {
      if (this.navigateBackPage == "default") {
        this.navigator.dismissAll();
      }
      else { this.navigator.navigateTo(this.navigateBackPage); }
    } else {
      if (!!this.callBackFn) {
        this.navigator.dismiss();
        this.callBackFn();
      }
      this.navigator.back();
    }
  };
}
